export default "__VITE_ASSET__66102cdb__"